import { getUserFullName, normalizeEmail } from 'utils';
import { LeadBasicInfo } from '../../models/Dashboard';

export const getLeadName = ({ firstName, lastName, email }: LeadBasicInfo) => {
  const name = getUserFullName(firstName, lastName);

  const normalizedEmail = normalizeEmail(email);

  return name
    ? `${name}${!lastName ? ` (${normalizedEmail})` : ''}`
    : normalizedEmail;
};
